export const types = {
    // Sync
    SET_CATEGORIES: "SET_CATEGORIES",  
    SET_SELECTED_CATEGORY: "SET_SELECTED_CATEGORY",
    CLEAN_SELECTED_CATEGORY: "CLEAN_SELECTED_CATEGORY",
    CHANGE_CATEGORY: "CHANGE_CATEGORY",    

    // Async    
    FETCH_CATEGORIES_ASYNC: "FETCH_CATEGORIES_ASYNC",
};
